import React from "react";
import { useStoreState } from "../hooks/ep";
import {
  useEnsureActionReportsData,
  useEnsureTripNotesData,
} from "../helpers/useEnsureData";
import AgTable from "./AgTable";
import "styled-components/macro";
import { useMaybeWithSaxecapDevColDefs } from "./saxecap-dev-coldefs";
import { Spinner } from "@blueprintjs/core";
import _ from "lodash";
import {
  ACTUAL_COUNT__COLDEF,
  CA_SAVINGS_COLDEF,
  CA_TOTAL_SAVINGS_COLDEF,
  NUM_PASSENGERS__COLDEF,
  OG_BASELINE_SAVINGS_COLDEF,
  OG_BASELINE_TOTAL_SAVINGS_COLDEF,
  OG_CA_FARE_COLDEF,
  OG_CA_SAVINGS_COLDEF,
  OG_CA_TOTAL_SAVINGS_COLDEF,
  OG_FARE_COLDEF,
  OG_TARGET_FARE_COLDEF,
  OG_TARGET_SAVINGS_COLDEF,
  OG_TARGET_TOTAL_SAVINGS_COLDEF,
  ONEWAY__OG_CARRIER_COLDEF,
  ONEWAY__OG_FLIGHTNO_COLDEF,
  PLANNER__COLDEF,
  REPORT_ACTION_BTN_COLDEF,
  ROUNDTRIP_F1__OG_CARRIER_COLDEF,
  ROUNDTRIP_F1__OG_FLIGHTNO_COLDEF,
  ROUNDTRIP_F2__OG_CARRIER_COLDEF,
  ROUNDTRIP_F2__OG_FLIGHTNO_COLDEF,
  XCA__SALES__COLDEF,
  XCA__TCC__COLDEF,
} from "./common-coldefs"; // DO NOT REMOVE. Necessary for using the css={`...`} prop

function TableInner() {
  const rowData = useStoreState((s) => s.actionReports.bookingsRowData);
  const colDefs = useMaybeWithSaxecapDevColDefs(DEFAULT_COL_DEFS);

  return (
    <AgTable rowData={rowData} columnDefs={colDefs} tableName="bookings" />
  );
}

export function BookingsTable() {
  const loading = [useEnsureActionReportsData(), useEnsureTripNotesData()];
  return _.max(loading) ? <Spinner /> : <TableInner />;
}

export const DEFAULT_COL_DEFS = [
  {
    headerName: "Submitter",
    field: "submitted_by",
    type: "categoryColumn",
    valueFormatter: ({ value }) => value.split("@")[0],
  },
  {
    headerName: "Submitted",
    field: "submitted_at",
    type: "timestampColumn",
    __timezone: "auto",
  },
  //
  // User-submitted booking details
  //
  {
    headerName: "# Tickets",
    field: "numTickets",
    type: "integerColumn",
  },

  ONEWAY__OG_CARRIER_COLDEF,
  ROUNDTRIP_F1__OG_CARRIER_COLDEF,
  ROUNDTRIP_F2__OG_CARRIER_COLDEF,

  ONEWAY__OG_FLIGHTNO_COLDEF,
  ROUNDTRIP_F1__OG_FLIGHTNO_COLDEF,
  ROUNDTRIP_F2__OG_FLIGHTNO_COLDEF,

  {
    headerName: "Price",
    field: "price",
    type: "moneyColumn",
  },
  {
    headerName: "Total Savings (vs Baseline)",
    field: "[Calc] Baseline Total Savings",
    type: "moneyColumn",
  },
  {
    headerName: "Total Savings (vs Target)",
    field: "[Calc] Target Total Savings",
    type: "moneyColumn",
  },
  OG_FARE_COLDEF,
  //
  // Comparing to Baseline Fare
  //
  {
    headerName: "Baseline Fare",
    field: "[Calc] Baseline Fare",
    type: "moneyColumn",
  },
  {
    headerName: "Savings (vs Baseline)",
    field: "[Calc] Baseline Savings",
    type: "moneyColumn",
  },

  //
  // Comparing to Target Fare
  //
  OG_TARGET_FARE_COLDEF,
  {
    headerName: "Savings (vs Target)",
    field: "[Calc] Target Savings",
    type: "moneyColumn",
  },
  {
    headerName: "Flight No.",
    field: "flightNumber", // Same payload field is used for "oneway" and "roundtrip"
    type: "textColumn",
  },
  {
    headerName: "Notes",
    field: "notes",
    type: "textColumn",
  },
  {
    headerName: "Resubscribe",
    field: "resubscribe",
    type: "booleanColumn",
  },
  {
    headerName: "Trip ID",
    field: "[Book] TripId",
    type: "textColumn",
  },
  {
    headerName: "Leg",
    field: "leg",
    type: "categoryColumn",
    __itinMode: "oneway",
  },
  //
  // Comparing to Current Avg Fare
  //
  OG_CA_FARE_COLDEF,
  CA_SAVINGS_COLDEF,
  CA_TOTAL_SAVINGS_COLDEF,
  //
  // Original values
  //
  OG_BASELINE_SAVINGS_COLDEF,
  OG_BASELINE_TOTAL_SAVINGS_COLDEF,
  OG_TARGET_SAVINGS_COLDEF,
  OG_TARGET_TOTAL_SAVINGS_COLDEF,
  OG_CA_SAVINGS_COLDEF,
  OG_CA_TOTAL_SAVINGS_COLDEF,

  PLANNER__COLDEF,
  XCA__TCC__COLDEF,
  XCA__SALES__COLDEF,
  NUM_PASSENGERS__COLDEF,
  {
    headerName: "Est Cnt",
    field: "Est Cnt",
    type: "integerColumn",
  },
  ACTUAL_COUNT__COLDEF,
  {
    headerName: "Type",
    field: "Budget Tour Type",
    type: "categoryColumn",
    __appMode: "dvy",
  },
  {
    headerName: "Group#",
    field: "[Book] Group#",
    type: "textColumn",
    __appMode: "dvy",
  },
  {
    headerName: "Tour#",
    field: "[Book] Tour#",
    type: "integerColumn",
    __appMode: "dvy",
  },
  {
    headerName: "School",
    field: "[Book] School",
    type: "textColumn",
    __appMode: "dvy",
  },
  {
    headerName: "A/P",
    field: "A/P",
    type: "categoryColumn",
    __appMode: "dvy",
  },
  REPORT_ACTION_BTN_COLDEF,
];
